import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "width", "title"];
import React from 'react';
import Svg from '../Svg';

var Twitter = function Twitter(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#6F768F' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '2.7rem' : _ref$width,
      _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Twitter icon' : _ref$title,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(Svg, _extends({
    title: title,
    width: width,
    viewBox: "0 0 27 22",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    d: "M23.6975 5.48115C24.0426 13.292 18.3605 22 8.30139 22C5.24254 22 2.39679 21.0797 -0.00012207 19.504C2.87391 19.852 5.74229 19.0323 8.01851 17.2052C5.64988 17.1607 3.649 15.5541 2.95689 13.3481C3.80741 13.5144 4.64472 13.466 5.40472 13.2534C2.80036 12.7159 1.00126 10.3107 1.05972 7.73741C1.79143 8.15309 2.62498 8.40249 3.51321 8.4315C1.10121 6.77845 0.418536 3.51296 1.83669 1.01696C4.50706 4.37719 8.4994 6.58705 13.0009 6.81905C12.2107 3.34669 14.7812 0 18.2794 0C19.8352 0 21.244 0.674752 22.2321 1.75358C23.4655 1.50611 24.6272 1.04209 25.6719 0.406011C25.2665 1.70331 24.4084 2.78988 23.2901 3.47816C24.3858 3.34283 25.4305 3.04508 26.3999 2.60234C25.6757 3.71984 24.7592 4.69813 23.6975 5.48115Z",
    fill: color
  }));
};

export default Twitter;